import { Div, Collection, CollectionPrinter, Span, Switch, Select, RefString } from "@tblabs/truffle";
import { TextField } from "../../Models/Description/Text/TextField";
import { TextEditor } from "./Text/TextEditor";
import { Field } from "../../Models/Description/Field";
import { FieldType } from "../../Models/Description/FieldType";
import { FaqsEditor } from "./Faq/FaqsEditor";
import { GalleryField } from "../../Models/Description/Gallery/GalleryField";
import { MarkdownEditor } from "./Markdown/MarkdownEditor";
import { TableItemsEditor } from "./Table/TableItemsEditor";
import { GalleryItemsEditor } from "./Gallery/GalleryItemsEditor";
import { MarkdownField } from "../../Models/Description/Markdown/MarkdownField";
import { FaqField } from "../../Models/Description/Faq/FaqField";
import { TableField } from "./Table/TableField";
import { OpinionsEditor } from "./Opinion/OpinionsEditor";
import { OpinionField } from "../../Models/Description/Opinion/OpinionField";
import { AddFieldBox } from "../Admin/AddFieldBox";
import { TextWithPictureEditor } from "./TextWithPicture/TextWithPictureEditor";
import { TextWithPictureField } from "../../Models/Description/TextWithPicture/TextWithPictureField";
import { Tab } from "../../Models/Product/Tab";
import { appendable } from "@tblabs/truffle/Core/appendable";


export class DescriptionEditor extends Div
{
    constructor(collection: Collection<Field>, tabs?: Collection<Tab>)
    {
        super();

        if (!tabs)
        {
            tabs = new Collection<Tab>();
        }

        const newOption = new RefString();
        const options: Record<string, () => Field> = {
            "Markdown": () => new MarkdownField({ Header: "Markdown" }),
            "Tekst": () => new TextField({ Header: "Tekst" }),
            "Tekst z obrazkiem": () => new TextWithPictureField({ Header: "Tekst z obrazkiem" }),
            "Faq": () => new FaqField({ Header: "Pytania i odpowiedzi" }),
            "Galeria": () => new GalleryField({ Header: "Galeria" }),
            "Tabela": () => new TableField({ Header: "Tabela" }),
            "Opinie": () => new OpinionField({ Header: "Opinie" }),
        }

        this.Append(
            new CollectionPrinter(collection, x =>
                new Switch<FieldType, appendable>(x.Type)
                    .Case(FieldType.Markdown, () => new MarkdownEditor(x as MarkdownField, collection, tabs))
                    .Case(FieldType.Faq, () => new FaqsEditor(x as FaqField, collection, tabs))
                    .Case(FieldType.Text, () => new TextEditor(x as TextField, collection, tabs))
                    .Case(FieldType.TextWithPicture, () => new TextWithPictureEditor(x as TextWithPictureField, collection, tabs))
                    .Case(FieldType.Gallery, () => new GalleryItemsEditor(x as GalleryField, collection, tabs))
                    .Case(FieldType.Table, () => new TableItemsEditor(x as TableField, collection, tabs))
                    .Case(FieldType.Opinion, () => new OpinionsEditor(x as OpinionField, collection, tabs))
                    .Default(() => new Span(`Unknown description field type "${x.Type}"`))
                    .Execute()
            ),
            new Select(newOption, Object.keys(options))
                .AddDefaultOption("➕ Dodaj")
                .OnChange(v =>
                {
                    collection.Add(options[v]());
                    newOption.value = "";
                })
            ,
        )
    }
}
